import ENV from '@/constant/env.js';

const domain = ENV.apiDomain;
const url = {
  lambda: {
    auth: domain + 'auths/',
    user: domain + 'users/',
    agency: domain + 'agencies/',
    certification: domain + 'certifications/',
    province: domain + 'provinces/',
    tournament: domain + 'tournaments/',
    payment: domain + 'payments/',
    file: domain + 'files/',
    carousel: domain + 'carousels/',
    announcement: domain + 'announcements/',
    order: domain + 'orders/',
    notification: domain + 'notifications/',
    exam: domain + 'exams/',
    events: domain + 'events/',
  },
};

export default url;
